import "core-js/modules/es6.function.name";
import SysMenuItem from "./SysMenuItem.vue";
export default {
  name: 'sys-menu',
  components: {
    SysMenuItem: SysMenuItem
  },
  data: function data() {
    return {
      activeName: "",
      openNames: []
    };
  },
  computed: {
    menuHash: function menuHash() {
      return this.$store.state.menuHash;
    },
    menuList: function menuList() {
      return this.menuHash['Module'].children || [];
    }
  },
  methods: {
    getActiveMenu: function getActiveMenu(path) {
      var _this = this;
      var menuHash = this.menuHash;
      for (var name in menuHash) {
        var menu = menuHash[name];
        if (menu.path === path) {
          this.activeName = name;
          this.openNames.splice(0);
          this.openNames.push(menu.pName);
          this.$nextTick(function () {
            _this.$refs.menu.updateOpened();
            // this.$refs.menu.updateActiveName();
          });
        }
      }
    }
  },
  watch: {
    "$route.path": function $routePath(path) {
      this.getActiveMenu(path);
    }
  },
  created: function created() {
    this.getActiveMenu(this.$route.path);
  }
};